export const getDocumentData = ({ documentation }) =>
  documentation.documentsData;
export const getCheckErrors = ({ documentation }) => documentation.errors;
export const getLoaders = ({ documentation }) => documentation.loaders.common;
export const getLoadersDoc = ({ documentation }) =>
  documentation.loaders.commonDoc;
